import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { Paths } from "../../../paths";
import { EntAnimalRegisterFilter } from "../../../models/filters/organic/animalRegisterFilter";
import { EntAnimalRegister } from "../../../models/organic/animalRegister";

export const animalRegisterApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getAnimalRegisterListAll: builder.query<ResponseDataGet<EntAnimalRegister>, EntAnimalRegisterFilter>({
	  query: (filter) => ({
		url: `${ Paths.organic.animalRegister }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getAnimalRegisterById: builder.query<ResponseDataTest<EntAnimalRegister>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.animalRegister }/${ id }`,
		method: 'GET'
	  })
	}),
	addAnimalRegister: builder.mutation<ResponseDataTest<EntAnimalRegister>, EntAnimalRegister>({
	  query: (body) => ({
		url: `${ Paths.organic.animalRegister }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editAnimalRegister: builder.mutation<ResponseDataTest<EntAnimalRegister>, EntAnimalRegister>({
	  query: (body) => ({
		url: `${ Paths.organic.animalRegister }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteAnimalRegister: builder.mutation<ResponseDataTest<EntAnimalRegister>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.animalRegister }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddAnimalRegisterMutation,
  useDeleteAnimalRegisterMutation,
  useEditAnimalRegisterMutation,
  useGetAnimalRegisterByIdQuery,
  useGetAnimalRegisterListAllQuery,
  useLazyGetAnimalRegisterListAllQuery
} = animalRegisterApi;
